import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import AddIcon from '@material-ui/icons/Add'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye'
import Grid from '@material-ui/core/Grid'
import { Calendar } from '@progress/kendo-react-dateinputs'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { listScheduledEmails, cancelScheduledEmail } from '../../actions/scheduledEmails'
import { listTemplates } from '../../actions/template'
import { REQUEST, SUCCESS } from '../../utils/statusConstants'
import SentMessagesAndStats from './SentMessagesAndStats'
import language from 'utils/vast-languagepack'

const mapStateToProps = state => ({
  scheduledEmailsByID: state.email.scheduledEmailsByID,
  templatesById: state.email.templatesById,
  session: state.auth.session,
  scheduledEmailLoadStatus: state.loadStatus.scheduledEmailsByID,
  templateLoadStatus: state.loadStatus.templatesById,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  listScheduledEmails,
  cancelScheduledEmail,
  listTemplates,
}, dispatch)

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  button: {
    margin: theme.spacing.unit,
    display: 'block',
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  root: {
    flexGrow: 1,
  },
  gridItem: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
})

class ScheduledEmailsPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      expanded: null,
      open: false,
      selectedDate: null,
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    })
  }

  handleDeleteClick = id => {
    this.props.cancelScheduledEmail(id)
  }

  handleNewClick = () => {
    this.props.history.push('?scheduledEmailID=new')
  }

  calendarChange = e => {
    const selectedDate = e.value
    this.setState({ selectedDate })
  }

  render() {
    const {
      classes,
      scheduledEmailsByID,
      listScheduledEmails,
      listTemplates,
      templatesById,
      session,
      scheduledEmailLoadStatus,
      templateLoadStatus,
    } = this.props
    const { expanded } = this.state

    // if ((!Object.keys(templatesById).length ||
    //       !Object.keys(scheduledEmailsByID).length) && session) {
    //         listTemplates().then(() => listScheduledEmails())
    // }

    // if (!Object.keys(scheduledEmailsByID).length && session) {
    //   listScheduledEmails()
    // }

    if (session) {
      if (templateLoadStatus === null) {
        listTemplates()
      }
      if (scheduledEmailLoadStatus === null) {
        listScheduledEmails()
      }
    }



    const panels = (
      templateLoadStatus === SUCCESS && scheduledEmailLoadStatus === SUCCESS
    ) && Object.keys(scheduledEmailsByID).length ?
      (Object.keys(scheduledEmailsByID).map(id => {
        const scheduledEmail = scheduledEmailsByID[id]
        const templateName = templatesById[scheduledEmail.trigger_data.template_id] ?
          templatesById[scheduledEmail.trigger_data.template_id].Template.TemplateName :
          'none found'
        const whenToSendDate = new Date(scheduledEmail.when_to_send)
        const panel = (
          <ExpansionPanel
            key={`scheduledEmailPanel${id}`}
            expanded={expanded === `panel${id}`}
            onChange={this.handleChange(`panel${id}`)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>
                <Link to={`?scheduledEmailID=${id}`}>
                  {templateName}
                </Link>
              </Typography>
              <Typography>{whenToSendDate.toString()}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Tooltip title={language.emailPage.toolTips.viewSchedule}>
                <Link to={`?scheduledEmailID=${id}`}>
                  <IconButton
                    color="secondary"
                    className={classes.button}
                    aria-label="View scheduled email"
                  >
                    <RemoveRedEyeIcon />
                  </IconButton>
                </Link>
              </Tooltip>
              <Tooltip title={language.emailPage.toolTips.cancelSchedule}>
                <IconButton
                  color="secondary"
                  className={classes.button}
                  aria-label="Cancel scheduled email"
                  onClick={() => this.handleDeleteClick(id)}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )

        if (this.state.selectedDate) {
          if (
            this.state.selectedDate.getFullYear() === whenToSendDate.getFullYear() &&
              this.state.selectedDate.getDate() === whenToSendDate.getDate() &&
              this.state.selectedDate.getMonth() === whenToSendDate.getMonth()
          ) {
            return panel
          } else {
            return null
          }
        } else {
          return panel
        }
      })) :
      (
        scheduledEmailLoadStatus === REQUEST || scheduledEmailLoadStatus === null ?
          <CircularProgress className={classes.progress} color="secondary" /> :
          <Typography variant="h2" gutterBottom>
            {language.emailPage.noResultsDisplay}
          </Typography>
      )

    const jwtToken = (session ?  session.idToken.jwtToken : null)
    // console.log("templatesById",templatesById)

    return (
      <div className={classes.root}>
        <h1>{language.emailPage.scheduledEmails}</h1>
        <Grid container spacing={24}>
          {/*<Grid item xs={0} s={0} m></Grid>*/}
          <Grid item s={3}>
            <Calendar
              onChange={e => this.calendarChange(e)}
            />
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => this.setState({ selectedDate: null })}
              disabled={this.state.selectedDate === null}
            >
              {language.emailPage.clearDate}
            </Button>
          </Grid>
          <Grid item xs s={9}>
            {panels}
          </Grid>
        </Grid>
        <SentMessagesAndStats templatesById={templatesById} jwtToken={jwtToken}></SentMessagesAndStats>
        <Tooltip title={language.emailPage.labels.scheduleEmail} placement="left">
        <Button
        color="secondary"
        variant="fab"
        aria-label="Add"
        className={classNames(classes.button, classes.floatingActionButton)}
        onClick={() => this.handleNewClick()}
        >
        <AddIcon />
        </Button>
        </Tooltip>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ScheduledEmailsPage))
